import { HttpClient } from '#client/http/index'
import {
  MeParams,
  ReservationsMeResponse,
  TimetableId,
  CreateReservationResponse,
  ReservationId,
  DestroyReservationResponse,
  type ListPastReservationsParams,
  type PastReservation,
} from '#client/resources/index'
import { ApiResponse, PagerMeta } from '#client/resources/types'

export const me = async (
  { httpClient }: { httpClient: HttpClient },
  params?: MeParams,
): Promise<ApiResponse<ReservationsMeResponse, PagerMeta>> =>
  await httpClient.get('/user/reservations/me', { params })

export const create = async (
  { httpClient }: { httpClient: HttpClient },
  timetableId: TimetableId,
) => {
  const { data }: ApiResponse<CreateReservationResponse> =
    await httpClient.post('/user/reservations', {
      timetableId,
    })
  return data
}

export const destroy = async (
  { httpClient }: { httpClient: HttpClient },
  id: ReservationId,
) => {
  const { data }: ApiResponse<DestroyReservationResponse> =
    await httpClient.delete(`/user/reservations/${id}`)
  return data
}

export const listPastReservations = async (
  { httpClient }: { httpClient: HttpClient },
  params?: ListPastReservationsParams,
) => {
  const { data, meta }: ApiResponse<PastReservation[], PagerMeta> =
    await httpClient.get('/user/reservations/me/past', { params })

  return { data, meta }
}
